import api, { baseURL } from "../../../../utils/api"

export const getAllConsultants = (page, limit, searchQuery) =>{
	return api.get(`${baseURL}/user/allconsultants?search=${searchQuery ? searchQuery : ""}&page=${page}&size=${limit}`);
}

export const deleteconsultant = (consultantId) =>{
	return api.delete(`${baseURL}/user/deleteuser?id=${consultantId}`);
}

export const importresource = (formData) => {
	return api.post(
	  `${baseURL}/user/uploadfile/addprofessional`,
	  formData,
	  {
		headers: {
		  "Content-Type": "multipart/form-data",
		},
	  }
	);
  };

export const updateConsultantToFlexpert = (userId, flexExpert, salaryDetails) => {
	const payload = {
		userId,
		salaryDetails
	};
	
	if (flexExpert !== null && flexExpert !== undefined) {
		payload.flexExpert = flexExpert;
	}
	
	return api.put(
	  `${baseURL}/user/update-consultant-to-flexpert`,
	  payload
	);
};